import unsecured, {secured as axios}  from '../../../axios';


export class Subscription {
  static async getSubscriptionList() {
    const res = await unsecured.get(`/subscriptions`);
    return res.data;
  }

  static async findById(id) {
    const list = await this.getSubscriptionList();
    return list.filter(subscription => subscription.id == id);
  }

  static async createSubscriptionSession(
    subscriptionId,
    recurrent = false,
    coupon = '',
  ) {
    const res = await axios.post(
      `/subscription/${subscriptionId}/session`,
      {},
      {
        params: {
          recurrent: recurrent ? 'yes' : 'no',
          ...('' !== coupon ? {coupon} : {}),
        },
      },
    );
    return res.data;
  }

  static async saveSubscription(sessionId) {
    const res = await axios
      .post(`/subscription/save`, {
        sessionId: sessionId,
      })
      .then(res => {
        console.log(res);
      });

    return res;
  }
}
